import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor() {
    this.loadScript();
  }
  loadScript(): void {
    if (!!environment.analytics.plausible.analyticsEnabled) {
      const script = document.createElement('script');
      script.defer = true;
      script.dataset.domain = environment.analytics.plausible.dataDomain;
      script.src = environment.analytics.plausible.jsSource;
      document.head.appendChild(script);
    }
  }
}
